import type { ProColumns } from '@ant-design/pro-components'
import { formatShanghaiDateTime } from '@/const/date.ts'
import { BILL_KINDS } from '@/features/bill/index.ts'
import { formatAmount } from '@/utils/money.ts'
import type { CustomerSendPreviewData } from '../types.ts'

export const customerSendColumns: ProColumns<CustomerSendPreviewData['data'][number]>[] = [
  { title: 'ID', dataIndex: 'id', copyable: true, width: '5rem' },
  { title: '账单号', dataIndex: 'billNo', copyable: true, width: '13rem' },
  { title: '经营主体', dataIndex: 'organizationName', width: '12rem', ellipsis: true },
  { title: '费用类型', dataIndex: 'feeType', valueEnum: BILL_KINDS, width: '7rem' },
  {
    title: '待收金额',
    dataIndex: 'amount',
    align: 'right',
    width: '8rem',
    renderText: (value: string) => `¥${formatAmount(value)}`
  },
  {
    title: '创建时间',
    dataIndex: 'createdAt',
    width: '11rem',
    renderText: (value: Date) => formatShanghaiDateTime(value)
  }
]
